/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of a device pairing session.  Status flow: pending -> completed        -> expired        -> cancelled
 */
export enum PairingSessionStatus {
    PENDING = 'pending',
    COMPLETED = 'completed',
    EXPIRED = 'expired',
    CANCELLED = 'cancelled',
}
